import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-player-sms-log',
  templateUrl: './player-sms-log.component.html',
  styleUrls: ['./player-sms-log.component.scss']
})
export class PlayerSmsLogComponent {

  public sms_list: any[] = [];
  public is_loading = false;
  public mobile: string = '';
  public player_name: string = '';

  @Output() closeEvent = new EventEmitter();

  @Input() set setPlayer(player: any) {
    if (!player) return;
    this.mobile = player.mobile || '';
    this.player_name = player.name || player.username || '';
    this.load();
  }

  constructor(private http: HttpService) {}

  async load() {
    if (!this.mobile) return;
    this.is_loading = true;
    const rtn: any = await this.http.post('/admin/company/sms/list-by-mobile', { mobile: this.mobile });
    this.sms_list = rtn.status ? (rtn.sms || []) : [];
    this.is_loading = false;
  }

  close() { this.closeEvent.emit(); }
}
